import {
  actions,
  getContentEntityTypeNavigationsDataTableAsync,
  getContentEntityTypeNavigationByIdAsync,
  createContentEntityTypeNavigationAsync,
  editContentEntityTypeNavigationAsync,
} from './slices';

export const ContentEntityTypeNavigationsActions = {
  ...actions,
  getContentEntityTypeNavigationsDataTableAsync,
  getContentEntityTypeNavigationByIdAsync,
  createContentEntityTypeNavigationAsync,
  editContentEntityTypeNavigationAsync,
};

export * from './thunkHandlers';
